import defs from '../_core/defs.js';
import forEach from '../_helpers/foreach.js';
import { toNodes, uniqueNodes } from '../_dom/index.js';
var customSelectorReg = /\s*:bound\(([^(]*)\)\s*([\S\s]*)\s*|\s*:sandbox\s*([\S\s]*)\s*/;
var randomAttr = Math.random().toString().replace('0.', 'x') + "y"; // x12345y
// splits a selector list by its top-level commas, keeping the ones inside :is(), [attr="a,b"] etc
function splitSelectorList(selectorList) {
  var selectors = [];
  var depth = 0;
  var quote = null;
  var start = 0;
  for (var i = 0; i < selectorList.length; i++) {
    var char = selectorList[i];
    if (quote) {
      if (char === '\\') {
        i += 1;
      } else if (char === quote) {
        quote = null;
      }
    } else if (char === '"' || char === "'") {
      quote = char;
    } else if (char === '(' || char === '[') {
      depth += 1;
    } else if (char === ')' || char === ']') {
      depth -= 1;
    } else if (char === ',' && depth === 0) {
      selectors.push(selectorList.slice(start, i));
      start = i + 1;
    }
  }
  selectors.push(selectorList.slice(start));
  return selectors;
}
// select and selectAll look inside the sandbox: a plain part of a list with :bound(KEY) becomes ":sandbox part"
export function scopeToSandbox(selectorList) {
  return splitSelectorList(selectorList).map(function (selector) {
    return customSelectorReg.test(selector) ? selector : ":sandbox " + selector;
  }).join(',');
}
// the function selects nodes based on a selector (including custom values, eg :sandbox)
// TODO: selectNodes looks not good, it needs to be refactored and accelerated if possible
export default function selectNodes(object, givenSelector) {
  var result = [];
  var def = defs.get(object);
  // an object without bindings has no :sandbox or :bound(KEY) nodes; plain selectors of the list still select
  var props = def ? def.props : {};
  var selectors = splitSelectorList(givenSelector);
  forEach(selectors, function (selector) {
    var execResult = customSelectorReg.exec(selector);
    if (execResult) {
      var boundKey = execResult[3] !== undefined ? 'sandbox' : execResult[1];
      var subSelector = execResult[3] !== undefined ? execResult[3] : execResult[2];
      var propDef = props[boundKey];
      if (propDef) {
        var bindings = propDef.bindings;
        if (bindings) {
          var boundNodes = Array(bindings.length);
          forEach(bindings, function (binding, i) {
            boundNodes[i] = binding.node;
          });
          // if native selector passed after :bound(KEY) is not empty string
          // for example ":bound(KEY) .my-selector"
          if (subSelector) {
            // if native selector contains children selector
            // for example ":bound(KEY) > .my-selector"
            if (subSelector.indexOf('>') === 0) {
              // selecting children
              forEach(boundNodes, function (node) {
                // a text or attribute node (bound by parseBindings) has no children
                if (!node.setAttribute) return;
                node.setAttribute(randomAttr, randomAttr);
                var selected = node.querySelectorAll("[" + randomAttr + "=\"" + randomAttr + "\"] " + subSelector);
                result = uniqueNodes(result, selected);
                node.removeAttribute(randomAttr);
              });
            } else {
              // if native selector doesn't contain children selector
              forEach(boundNodes, function (node) {
                if (!node.querySelectorAll) return;
                var selected = node.querySelectorAll(subSelector);
                result = uniqueNodes(result, selected);
              });
            }
          } else {
            // if native selector is empty string just add bound nodes to result
            result = uniqueNodes(result, boundNodes);
          }
        }
      }
    } else {
      // if it's native selector (no custom things)
      result = uniqueNodes(result, toNodes(selector));
    }
  });
  return result;
}